// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"721":"02a227f4","952":"a847ab9b"}[chunkId] + ".chunk.js";
};